// extracted by mini-css-extract-plugin
export default {"backgroundPodheader":"background_podheader_backgroundPodheader__ZnjF3","content":"background_podheader_content__YaaWn"};